import { html, ifDefined } from "../../"
import { T } from "../../global/globals"

import type {
  HookViewRowCellClass_ReturnType,
  HookViewRowCellClass_Type,
} from "../../global/hooks"
import { HookViewRowCellClass } from "../../global/hooks"

import { SYSBaseElement } from "../sysbaseelement"
import { _GetFeedback } from "./detailview/helpers"
import type { CachedRendererData } from "./helpers"
import { _GetAlign, _GetRowDisplayValue } from "./helpers"
import type { TableRowDataDef } from "./rowwrapper"
import type { DisplayMode, OvlSysColumn } from "./table"

export type CellClass = {
  className?: string
  tooltip?: string
  draggable?: boolean
}

export let cachedRendererFn: Map<string, CachedRendererData> = new Map<
  string,
  CachedRendererData
>()
export class SYSTableRow extends SYSBaseElement {
  props: any
  row: TableRowDataDef
  hasLazyImage: boolean
  async init() {
    this.row = this.props()
    await super.init()
  }
  async afterRender() {
    if (this.hasLazyImage) {
      let lazyImages = this.querySelectorAll(".ovl-lazy-image")
      lazyImages.forEach((element) => {
        this.row.intersectionObserver.observe(element)
      })
    }
  }
  async getUI() {
    let row = this.row.row
    let def = this.row.tableDef

    let feedback = _GetFeedback(def, row, this.row.key)

    if (def.uiState.currentlyAddingKey === this.row.key) {
      return html`<!---->`
    }
    let columns = def.columns

    let visibleColumns = def.uiState.columnsRenderingState.visibleInTable

    // see if we can gbet custom class names for the row columns
    // eg. to color a cell
    // this will also be used for detailview, differentiating by param isDetail
    let customRowCellClasses: HookViewRowCellClass_ReturnType
    let functionName = HookViewRowCellClass.replace("{subFeature}", "")
    let fn = this.actions.app.features[def.feature]
    if (fn?.hooks?.[functionName]) {
      customRowCellClasses = fn.hooks[functionName](<HookViewRowCellClass_Type>{
        columns: def.columns,
        row,
        rowKey: this.row.key,
        displayMode: <DisplayMode>"Table",
        feature: def.feature,
        tableDefId: def.id,
        def,
      })
    }
    let isFirstCol = true
    return html`
      ${visibleColumns.map((k) => {
        let rowFnFeedbackHint
        if (isFirstCol && feedback) {
          rowFnFeedbackHint = feedback
        }
        isFirstCol = false

        let customRowCellClass: string = ""
        let draggable =
          customRowCellClasses?.[k]?.draggable === true ? true : undefined
        let tooltip = customRowCellClasses?.[k]?.tooltip
        if (!tooltip) {
          tooltip = undefined
        }
        if (customRowCellClasses?.[k]?.className) {
          customRowCellClass = customRowCellClasses[k].className
        }

        let col = columns[k]
        let outInfo = { isHookValue: false }
        let rowPart = _GetRowDisplayValue(
          def,
          k,
          this.row.row,
          this.row.key,
          "Table",
          undefined,
          undefined,
          undefined,
          outInfo
        )

        let tdclass = ""
        if (outInfo.isHookValue) {
          tdclass += "ovl-hookvalue "
        }
        if (col.ui.wrapping?.maxCharacters && (def.uiState?.layoutMode !== "Large" || col.ui.wrapping.alsoForLargeMode)) {
          tdclass += `ovl-text-maxcharacter-${col.ui.wrapping.maxCharacters}`
        } else if (col.ui.wrapping?.noWrap) {
          tdclass += "ovl-text-nowrap"
        }
        let expandHandle: any = ""
        if (col.ui.expandTableCellOnClick) {
          expandHandle = html`<span
            class="ovl-expand-onclick"
            title="${T("SYSClickToExpand")}"
          ></span>`
        }

        // needs to be ignored to get css white-space: line-wrap work correctly
        // prettier-ignore
        return html`
          <td title=${ifDefined(tooltip)} draggable=${ifDefined(draggable)} data-col=${k} class=${`fd-table__cell ${_GetAlign(col.ui.align)} ovltvc ${this.row.thHeaderEnd[k] ? "thGrp" : ""} col__${k} ctl__${col.control} tpe__${columns[k].type} ${customRowCellClass}`}><div class="ovl-td ${tdclass}">${rowPart}${rowFnFeedbackHint}${expandHandle}</div></td>
        `
      })}
    `
  }
}
